import useIsSmall from "@/hooks/useIsSmall";
import useDashboardAccess from "@/hooks/useDashboardAccess";
import BarberOverview from "./barberOverview";
import ManagerHome from "./home/ManagerHome";
import StylistHome from "./home/StylistHome";
import DashboardOverviewPage from "./overview";

export default function DashboardLanding() {
  const isSmall = useIsSmall();
  const { isStylist } = useDashboardAccess();
  if (isStylist) return isSmall ? <StylistHome /> : <BarberOverview />;

  return isSmall ? <ManagerHome /> : <DashboardOverviewPage />;
}
